module.exports = __webpack_public_path__ + "img/pms_6.eb862289.png";